import '../../../common/dashboard/filters/filter.js.coffee';# Added by Script 
Namespace 'CustomerVisualMode.Filters'

class CustomerVisualMode.Filters.UsersGroupFilter extends Common.Dashboard.Filters.Filter

  @FILTER_TYPE: 'users_group'
  removable: true

  constructor: ({values}) ->
    return unless values
    super
      values:
        ids: values.ids || []
        no_group: values.no_group

  getFilterType: ->
    CustomerVisualMode.Filters.UsersGroupFilter.FILTER_TYPE

  getValues: ->
    return [] unless @values
    values = []
    values = values.concat(@values.ids.map((id) -> id: id, name: id))
    values.push(id: @_noTeamId(), name: @_noTeamLabel(), icon: 'unassigned-icon') if @values.no_group
    values

  hasValues: ->
    @values.ids.length > 0 || @values.no_group

  _valuesToJSON: ->
    @values

  removeValue: (valueToRemove) =>
    return @_removeNoTeamValue() if valueToRemove.id == @_noTeamId()
    @values.ids = _.reject(@values.ids, (value) -> value == valueToRemove.id)

  _removeNoTeamValue: ->
    @values.no_group = false

  _noTeamLabel: ->
    I18n.t('common.session.filters.users_group.no_team')

  _noTeamId: ->
    CustomerVisualMode.Filters.SingleFilters.UsersGroupFilterView.NO_GROUP_VALUE
